import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';

interface CardWrapperProps {
    disabled?: boolean;
}

export const CardWrapper = styled.div<CardWrapperProps>`
    margin-bottom: ${({ theme: { space } }) => space[5]};
    margin-top: ${({ theme: { space } }) => space[5]};
    border: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.large};
    background-color: ${({ theme }) => theme.colors.neutral__light__00};
    &:last-child {
        margin-bottom: 0;
    }

    h3 {
        padding: ${({ theme: { space } }) => space[5]} ${({ theme: { space } }) => space[6]};
        border-bottom: ${({ disabled, theme }) =>
            disabled ? 'none' : `1px solid  ${theme.colors.neutral__light__30}`};
        color: ${({ theme }) => theme.colors.blue__primary__70};
        opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
        margin-bottom: ${({ disabled, theme: { space } }) => (disabled ? '0' : `${space[5]}`)};
        ${breakpointUp.md`
            padding: ${({ theme: { space } }) => space[5]} ${({ theme: { space } }) => space[7]};
       `}
    }

    h4 {
        font-family: ${({ theme }) => theme.fonts.sansSerif.family};
        color: ${({ theme }) => theme.colors.blue__primary__100};
        font-size: ${({ theme }) => theme.fontSizes[4]};
    }
`;

export const CardBody = styled.div`
    padding: ${({ theme: { space } }) => space[5]} ${({ theme: { space } }) => space[6]};
    ${breakpointUp.md`
           padding: ${({ theme: { space } }) => space[5]} ${({ theme: { space } }) => space[7]};
      `}
`;
